'use client';

import DetailsArbre from '../arbre/details';

interface InventaireDetailsRouterProps {
  inventaireId: number;
  initialData?: any;
  type: 'ARBRE' | 'EPAYSAGE';
}

export default function InventaireDetailsRouter({ inventaireId, initialData, type }: InventaireDetailsRouterProps) {

  return <DetailsArbre inventaireId={inventaireId} initialData={initialData} />;
}
